import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcTradesListWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderTradesList();
}
